/**
 * @generated SignedSource<<a67fba4f7f515ae8d708ef042ac1de82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionBar_AtlassianHubHome$data = ReadonlyArray<{
  readonly description: {
    readonly default: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly name: {
    readonly default: string;
  } | null | undefined;
  readonly " $fragmentType": "actionBar_AtlassianHubHome";
}>;
export type actionBar_AtlassianHubHome$key = ReadonlyArray<{
  readonly " $data"?: actionBar_AtlassianHubHome$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionBar_AtlassianHubHome">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "actionBar_AtlassianHubHome",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "HelpCenterPageDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v0/*: any*/)
    }
  ],
  "type": "HelpCenterPage"
};
})();

(node as any).hash = "3c9e24b1589165230d4cfe97c9f2a5ad";

export default node;
